/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Finnish
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Workplace Experience ‑tiimimme huolehtii nyt lahjapyynnöstä. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Kehut luotu',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Kehujesi luonti tai lahjan lähetys epäonnistui. Yritä tehdä erillinen tukipyyntö osoitteessa <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Jokin meni vikaan',
  'team-central.give-kudos.button': 'Anna kehuja',
  'team-central.give-kudos.close-button.label': 'Sulje laatikko',
  'team-central.give-kudos.confirm-close.title': 'Vahvista sulkeminen',
  'team-central.give-kudos.created.description.flag': 'Kehut on lähetetty. <a>Näytä kehut</a>',
  'team-central.give-kudos.created.title.flag': 'Kehut luotu',
  'team-central.give-kudos.creation.failed.description.flag': 'Kehujasi ei voitu luoda.',
  'team-central.give-kudos.creation.failed.title.flag': 'Jokin meni vikaan',
  'team-central.give-kudos.error-icon.label': 'Virhe',
  'team-central.give-kudos.success-icon.label': 'Onnistui',
  'team-central.give-kudos.unsaved.warning': 'Tekemiäsi muutoksia ei tallenneta.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Peruuta',
  'team-central.give-kudos.unsaved.warning.close': 'Sulje'
};